import {
    useContext,
    Context,
} from 'react';

import {
    LoadingProvider,
    LoadingContext,
    Loading,
} from './components/LoadingProvider';

export const useLoading = (): Loading => useContext(LoadingContext);

export { LoadingProvider };
